<template>
  <section class="four">
    <div class="container">
      <div class="wrap">
        <h3>Projects</h3>
      </div>
      <div class="projects">
        <div class="project" v-for="(project, index) in projects" :key="index">
          <div :data-aos="project.direction" class="card">
            <div class="front">
              <p>{{ project.time }}</p>
              <h4>{{ project.name }}</h4>
              <p>{{ project.description }}</p>
            </div>
            <div class="back">
              <img :src="project.image" />
              <p>{{ project.detail }}</p>
              <a :href="project.link" target="_blank">Click</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ProjectComponent",
  data() {
    return {
      projects: [
        {
          name: "Wordpress",
          description: "Block theme and plugin with React",
          time: "April 2023",
          link: "https://github.com/IzumiKeiki/wordpress",
          detail:
            "'Quiz' and 'Banner', sample Blocks implemented as plugins for existing websites or as default features in a new theme.",
          image: require("../assets/project/Project10.png"),
          direction: "fade-up-right",
        },
        {
          name: "Java",
          description: "CRUD webpage with PostgreSQL",
          time: "March 2023",
          link: "https://github.com/IzumiKeiki/JavaWeb",
          detail:
            "User CRUD (Create, Read, Update, and Delete) website showcasing Java and PostgreSQL.",
          image: require("../assets/project/Project9.png"),
          direction: "fade-up-left",
        },
        {
          name: "Let's have dessert",
          description: "A mini-app with Quasar and Pinia",
          time: "January 2023",
          link: "https://lets-have-dessert.netlify.app/#/",
          detail:
            "A shopping website implemented using Quasar, a framework base on Vue.",
          image: require("../assets/project/Project8.png"),
          direction: "fade-up-left",
        },
        {
          name: "Movie bookmarks",
          description: "A mini-app with React and Movie API",
          time: "January 2023",
          link: "https://movie-bookmarks.netlify.app/",
          detail:
            "The site fetches and displays data gathered via an external API, locally caching user selections",
          image: require("../assets/project/Project7.png"),
          direction: "fade-up-right",
        },
        {
          name: "Login page",
          description: "A mini-app with Vue and Firebase",
          time: "December 2022",
          link: "https://login-w-firebase.netlify.app/",
          detail:
            "Registration and Login using Firebase Auth and NoSQL Database.",
          image: require("../assets/project/Project6.png"),
          direction: "fade-up-left",
        },
        {
          name: "Musical",
          description: "A homepage with Vue",
          time: "December 2022",
          link: "https://musical-hp.netlify.app/",
          detail:
            "Multi-page website, including a contact page using Google Forms.",
          image: require("../assets/project/Project5.png"),
          direction: "fade-up-right",
        },
        {
          name: "Halloween",
          description: "A mini-game with vanilla Javascript",
          time: "November 2022",
          link: "https://enter-a-letter.netlify.app/",
          detail:
            "Cross-device compatible word-guessing game using JavaScript.",
          image: require("../assets/project/Project4.png"),
          direction: "fade-up-left",
        },
        {
          name: "Flower and Buffterfly",
          description: "A mini-game with vanilla Javascript",
          time: "June 2022",
          link: "https://flower-and-butterfly.netlify.app/",
          detail:
            "A simple game based around random number generation using JavaScript.",
          image: require("../assets/project/Project3.png"),
          direction: "fade-up-right",
        },
        // {
        //   name: "Get your dog",
        //   description: "A mini-game with vanilla Javascript",
        //   link: "https://get-your-dog.netlify.app/",
        //   image: require("../assets/project/Project2.png"),
        //   direction: "fade-up-left",
        // },
        {
          name: "Hamster's food",
          description: "A homepage with responsive design",
          time: "June 2022",
          link: "https://hamster-food.netlify.app/",
          detail:
            "Dynamic single-page website, implemented using Bootstrap and Javascript.",
          image: require("../assets/project/Project1.png"),
          direction: "fade-up-left",
        },
        {
          name: "School",
          description: "A completed homepage by blogspot",
          time: "February 2018",
          link: "https://obcnet-vn.blogspot.com/",
          detail:
            "Multipage website, contains contact details and education information.",
          image: require("../assets/project/Project0.png"),
          direction: "fade-up-right",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.four {
  background-image: linear-gradient(to top, #fff 94%, #2f9e44 94%);
}

.container {
  max-width: 1280px;
  margin: 0 auto 5rem;
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  h3 {
    border-bottom: 3px solid #1f0d14;
    padding: 0 1.5rem;
    margin: 3rem 9rem;
    font-family: "Acme", Arial, sans-serif;
    font-size: 3rem;
    color: #1f0d14;
    filter: drop-shadow(3px 5px 2px rgb(0 0 0 / 0.4));
  }

  .projects {
    display: flex;

    flex-wrap: wrap;
    justify-content: center;
  }
}

.card {
  margin: 2.5rem;
  width: 15rem;
  height: 23rem;
  position: relative;
  font-family: "Lato", Arial, sans-serif;

  .front,
  .back {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 23rem;
    box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.15);
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: all 0.8s ease;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    overflow: hidden;
    border-radius: 10px;
  }

  .front {
    justify-content: center;
    background-image: linear-gradient(to top left, #fff 85%, #1f0d14 99%);

    h4,
    p {
      display: block;
      padding: 1.5rem;
      text-align: center;
      color: #1f0d14;
    }

    h4 {
      font-size: 1.5rem;
      line-height: 2.5rem;
    }

    p {
      line-height: 1.5rem;
    }
  }

  .back {
    justify-content: flex-start;
    transform: rotateY(180deg);
    background-image: linear-gradient(to bottom right, #fff, #2f9e44);

    img {
      padding-top: 1rem;
      width: 90%;
      margin: 1rem;
    }

    padding: 0 1.5rem;

    a {
      text-transform: uppercase;
      text-decoration: none;
      margin-top: 1.75rem;
      padding: 1rem 3rem;
      display: inline-block;
      border-radius: 10rem;
      transition: all 0.2s;
      color: #1f0d14;
      background-color: #fff;

      &:hover {
        transform: translateY(-3px);
        box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.2);
      }

      &:active,
      &:focus {
        outline: none;
        transform: translateY(-1px);
      }
    }
  }

  &:hover .front {
    transform: rotateY(-180deg);
  }

  &:hover .back {
    transform: rotateY(0);
  }
}

@for $i from 1 through 10 {
  .project:nth-child(#{$i}) {
    .front {
      animation: flip-front 25s linear #{$i * 0.25 + 3}s infinite;
    }

    .back {
      animation: flip-back 25s linear #{$i * 0.25 + 3}s infinite;
    }

    .card {
      &:hover .front {
        animation: none;
      }

      &:hover .back {
        animation: none;
      }
    }
  }
}

@keyframes flip-front {
  5% {
    transform: rotateY(-180deg);
  }

  40% {
    transform: rotateY(-180deg);
  }

  45% {
    transform: rotateY(0);
  }
}

@keyframes flip-back {
  5% {
    transform: rotateY(0);
  }

  40% {
    transform: rotateY(0);
  }

  45% {
    transform: rotateY(180deg);
  }
}

@media screen and (max-width: 1280px) {
  .four {
    background-image: linear-gradient(to top, #fff 95.5%, #2f9e44 95.5%);
  }
}

@media screen and (max-width: 960px) {
  .four {
    background-image: linear-gradient(to top, #fff 96%, #2f9e44 96%);
  }
}

@media screen and (max-width: 750px) {
  .container {
    align-items: center;

    h3 {
      scale: 0.85;
    }
  }
}

@media screen and (max-width: 700px) {
  .four {
    background-image: linear-gradient(to top, #fff 94%, #2f9e44 94%);
  }

  .container {
    h3 {
      scale: 0.85;
    }
  }

  .card {
    margin: 1.5rem;
    width: 14rem;
    height: 23rem;

    .front,
    .back {
      height: 23rem;
    }
  }
}

@media screen and (max-width: 550px) {
  .four {
    background-image: linear-gradient(to top, #fff 97%, #2f9e44 97%);
  }
}
</style>
